import MenuRightSerivce from "@/service/MenuRightService";
import InviteNewCandidateService from "@/service/InviteNewCandidateService";
import JobAdsService from "@/service/JobAdsService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { CandidateInvited } from "@/model/CandidateInvited";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import jobApplicationForm from "./S090300-JobApplication/S090300-JobApplication.vue";
import Settings from "../../../constants/Settings";
export default {
  name: "JobApplication",
  components: {
    jobApplicationForm
  },
  mounted() {
    this.assignRights();
    this.getJobadListForCandidatesInvited();
  },
  data: () => ({
    jobApplicationLocalization: t,
    menuId: Settings.MenuID.JobApplicationForm,
    Settings: Settings,
    jobApplicationDictEnum: dictEnum,
    selectedJobCandidateInvited: new CandidateInvited(),
    jobAdList: [],
    menuRights: { allRights: {}, rightsForThisMenu: {} },
  }),
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getJobadListForCandidatesInvited() {
      const obj = {};
      const response = await JobAdsService.getJobadListForCandidates(obj);
      if (response.data.IsSuccess) {
        this.jobAdList = response.data.Data;
        this.getJobadListForCandidates();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getJobadListForCandidates() {
      var self = this;
      const obj = {
        candId: this.$route.params.candId,
      };
      const response = await InviteNewCandidateService.getCandidateInvited(obj);
      if (response.data.IsSuccess) {
        var candidate = response.data.Data;
        var jobDetail = self.jobAdList.find(
          (obj) => obj.JobAdCode == candidate.JobAdCode
        );
        // candidate.UserName = self.user.Lang == 'EN' ? jobDetail.UserEName : jobDetail.UserCName;
        // candidate.UserId = jobDetail.Interviewer;
        // candidate.JobName = self.user.Lang == 'EN' ? jobDetail.JobEDesc : jobDetail.JobCDesc;
        self.$refs.refJobApplicationForm.$data.candidateInvited = new CandidateInvited();
        self.selectedJobCandidateInvited = candidate;
        self.$refs.refJobApplicationForm.$data.e1 = 1;
        self.$refs.refJobApplicationForm.$validator.reset();
        self.$refs.refJobApplicationForm.vErrors.clear();
        self.$refs.refJobApplicationForm.$data.selectJobCandidateInvited = candidate;
        self.$refs.refJobApplicationForm.$data.IsCandidateForm = false;
        self.$refs.refJobApplicationForm.getAllCandidateInvitedListByCandid();
        self.$refs.refJobApplicationForm.getCandidateInvitationDetail();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090300-JobApplicationForm/S090300-CandidateJobApplicationForm.js